import { render, staticRenderFns } from "./PaperStore.vue?vue&type=template&id=631b19f0&scoped=true"
import script from "./PaperStore.vue?vue&type=script&lang=js"
export * from "./PaperStore.vue?vue&type=script&lang=js"
import style0 from "./PaperStore.vue?vue&type=style&index=0&id=631b19f0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "631b19f0",
  null
  
)

export default component.exports